import ContinuePage from "@components/ContinuePage"

export default function PetsDoingGreatPage() {
  return <ContinuePage emoji="💪" translationKey="petsDoingGreat" />
}
